import { Component } from '@angular/core';

@Component({
  selector: 'app-manuel-utilisation',
  templateUrl: './manuel-utilisation.component.html',
  styleUrls: ['./manuel-utilisation.component.scss'],
})
export class ManuelUtilisationComponent {
  activeSection = 'intro';
  searchQuery = '';

  sections = [
    { id: 'intro',          label: 'Introduction',         icon: 'fa-home' },
    { id: 'premiers-pas',   label: 'Premiers pas',         icon: 'fa-rocket' },
    { id: 'parametrage',    label: 'Paramétrage',          icon: 'fa-cogs' },
    { id: 'production',     label: 'Production',           icon: 'fa-briefcase' },
    { id: 'prestation',     label: 'Prestation',           icon: 'fa-medkit' },
    { id: 'medical',        label: 'Médical',              icon: 'fa-heartbeat' },
    { id: 'sinistre',       label: 'Sinistre',             icon: 'fa-exclamation-triangle' },
    { id: 'comptabilite',   label: 'Comptabilité',         icon: 'fa-calculator' },
    { id: 'administration', label: 'Administration',       icon: 'fa-users' },
    { id: 'editique',       label: 'Éditique & Rapports',  icon: 'fa-print' },
    { id: 'faq',            label: 'FAQ',                  icon: 'fa-question-circle' },
    { id: 'glossaire',      label: 'Glossaire',            icon: 'fa-book' },
  ];

  faq = [
    {
      q: 'Comment réinitialiser mon mot de passe ?',
      a: 'Sur la page de connexion, cliquez sur "Mot de passe oublié" et entrez votre adresse email. Un lien de réinitialisation vous sera envoyé.',
    },
    {
      q: 'Pourquoi je ne vois pas certains menus ?',
      a: 'L\'accès aux modules est contrôlé par les habilitations de votre rôle. Contactez votre administrateur pour modifier vos droits.',
    },
    {
      q: 'Comment ventiler un paiement sur plusieurs factures ?',
      a: 'Dans Comptabilité › Encaissement, sélectionnez le partenaire, saisissez le montant total et choisissez le mode de règlement. Le système répartit automatiquement le montant sur les factures les plus anciennes en premier.',
    },
    {
      q: 'Qu\'est-ce que le crédit disponible ?',
      a: 'Le crédit disponible est un surplus d\'encaissement mis en réserve lorsqu\'un paiement dépasse le total des factures dues. Il est automatiquement utilisé lors du prochain encaissement.',
    },
    {
      q: 'Comment rembourser un trop-perçu à un partenaire ?',
      a: 'Dans Comptabilité › Compte partenaire, sélectionnez le partenaire concerné et cliquez sur le bouton "Ristourner". Saisissez le montant et un motif. Le système enregistre le remboursement dans le journal.',
    },
    {
      q: 'Comment importer des bénéficiaires en masse ?',
      a: 'Dans Production › Info bénéficiaire, cliquez sur "Import Excel", téléchargez d\'abord le modèle, remplissez-le en respectant le format, puis importez le fichier.',
    },
    {
      q: 'Comment générer un rapport PDF ?',
      a: 'Dans le module Éditique, choisissez le type de rapport, définissez la période et les filtres souhaités, puis cliquez sur "Générer PDF". Le fichier est téléchargeable et archivé dans l\'historique des éditions.',
    },
    {
      q: 'Peut-on annuler une quittance émise ?',
      a: 'Oui, à condition qu\'elle n\'ait pas encore été encaissée. Depuis Production › Quittance › Quittances émises, sélectionnez la quittance et utilisez l\'action "Annuler". Une quittance déjà réglée ne peut pas être annulée directement.',
    },
  ];

  glossaire = [
    { terme: 'Garant',          def: 'Organisme financeur (assureur, mutuelle, caisse) qui prend en charge les prestations médicales selon le contrat.' },
    { terme: 'Souscripteur',    def: 'Entreprise ou personne qui souscrit un contrat d\'assurance santé pour le compte de ses employés ou membres.' },
    { terme: 'Bénéficiaire',    def: 'Personne physique couverte par le contrat (titulaire ou ayant droit).' },
    { terme: 'Police',          def: 'Contrat d\'assurance définissant les garanties, les plafonds et les exclusions pour un groupe de bénéficiaires.' },
    { terme: 'Quittance',       def: 'Avis de prime émis à l\'échéance (mensuelle, trimestrielle, annuelle) correspondant au montant dû par le souscripteur.' },
    { terme: 'Barème',          def: 'Grille tarifaire définissant les taux de remboursement par acte médical et par garantie.' },
    { terme: 'Tiers payant',    def: 'Dispositif permettant au bénéficiaire de ne pas avancer les frais. Le prestataire est réglé directement par la compagnie.' },
    { terme: 'RD (Relevé de Dépenses)', def: 'Récapitulatif des soins dispensés par un prestataire, soumis pour remboursement.' },
    { terme: 'Ventilation',     def: 'Répartition automatique d\'un paiement reçu sur plusieurs factures ou quittances impayées.' },
    { terme: 'Crédit disponible', def: 'Solde positif du compte d\'un partenaire résultant d\'un trop-perçu. Il est consommé en priorité lors du prochain encaissement.' },
    { terme: 'Ristourne',       def: 'Remboursement d\'un crédit disponible à un partenaire (garant, souscripteur) en fin d\'exercice ou sur demande.' },
    { terme: 'Déversement',     def: 'Export des mouvements comptables vers le logiciel de comptabilité externe.' },
    { terme: 'Entente préalable', def: 'Accord obligatoire du médecin conseil avant la réalisation de certains actes médicaux coûteux.' },
    { terme: 'Franchise',       def: 'Montant restant à la charge du bénéficiaire (non remboursé) pour chaque acte ou séjour.' },
    { terme: 'Plafond',         def: 'Montant maximum remboursable par acte, par garantie ou par période selon le contrat.' },
    { terme: 'Sinistre',        def: 'Événement déclenchant l\'intervention de la garantie (maladie, accident, hospitalisation).' },
    { terme: 'Décompte',        def: 'Document récapitulatif d\'un sinistre indiquant les montants engagés et la part prise en charge.' },
    { terme: 'Mouvement comptable', def: 'Écriture générée automatiquement pour chaque opération financière, destinée à l\'export vers le logiciel de comptabilité.' },
  ];

  openFaq: number | null = null;

  toggleFaq(i: number) {
    this.openFaq = this.openFaq === i ? null : i;
  }

  setSection(id: string) {
    this.activeSection = id;
    this.openFaq = null;
  }
}
